export const locale = {
  lang: 'en',
  data: {
    TRANSLATOR: {
      SELECT: 'Select your language',
    },
    MENU: {
      Keywords: 'Keywords',
      Next: 'Next',
      Previous: 'Previous',
      TotalQuranKaremCourseCount: 'Number of Quran Kareem courses',
      HomeWorkAttachment: 'Attached files',
      IsVisibleToApply: 'Visibility to apply',
      DueDate: 'Application deadline',
      ReadMore: 'Read more',
      FullText: 'Full text',
      BranchesCount: 'Number of centers',
      CoursesCount: 'Number of courses',
      AboutUs: 'About us',
      UpdatePassword: 'Update password',
      PageName: 'Page name',
      TeacherReports: 'Teacher reports',
      StudentReports: 'Student reports',
      GeneralReports: 'General reports',
      BranchesReports: 'Center reports',
      CourseReports: 'Course reports',
      LevelStageReports: 'Category and level reports',
      Admin: 'Admin',
      PrivacyPolicy: 'Privacy policy',
      CategoryType: 'Category type',
      PublicNews: 'Public news',
      CategoryNews: 'News categories',
      ShortText: 'Short text',
      ExamResult: 'Exam results',
      SetType: 'Select type',
      AddQuranKaremCourse: 'Course',
      LessonOrder: 'Lesson order',
      MeetingUrl: 'Meeting URL',
      StudentLessons: 'Student lessons',
      StudnetLesson: 'Student lessons',
      AttachmentUrl: 'Video URL',
      LessonName: 'Lesson name',
      QuranKaremLevelType: 'Type',
      ToAssignment: 'To lesson assignment',
      FromAssignment: 'From lesson assignment',
      Url: 'URL',
      AddAttachment: 'Add attachments',
      IsOrphan: 'Is the student an orphan',
      ExpectedTotalPageSaving: 'Expected number of pages to memorize',
      ExpectedTotalPageReview: 'Expected number of pages to review',
      ExamPoint: 'Exam score',
      RequiredCount: 'Number of mandatory questions',
      SetDetail: 'Set details',
      SelectExam: 'Select exam',
      QuranKaremExamSetTeacherExam: 'Assign exams and teachers to students',
      TotalPage: 'Total pages',
      AlmaherMangement: 'Al-Maher program management',
      ManagingFliexibleSetting: 'Managing Flexible Setting',
      AddQuestion: 'Add question',
      WrongPoint: 'Incorrect score',
      YouTubeUrl: 'YouTube URL',
      QuranKaremCourseName: 'Quran Kareem course name',
      QuranKaremStageName: 'Stage name',
      QuranKaremLevelName: 'Level name',
      CourseExamName: 'Course name',
      AppledCourseExam: 'Applicants for foundational course exam',
      AppledQuranKaremExam: 'Applicants for Quran Kareem exams',
      ExamName: 'Exam name',
      CourseStudents: 'Course students',
      SelectStudent: 'Select student',
      SelectTeacher: 'Select teacher',
      Cv: 'CV',
      ManagingBackPermissions: 'Backend permissions management',
      ManagingFrontPermissions: 'Frontend permissions management',
      SetLevel: 'Choose level',
      Attachments: 'Attachments',
      QuranCourseName: 'Course name',
      AddStageDetails: 'Add stage details',
      StagesDetails: 'Stage details',
      StudentsCount: 'Number of students',
      QuranKaremCourses: 'Quran Kareem courses',
      QuranKaremCoursesMangments: 'Courses management',
      TotalCourseCount: 'Total number of courses',
      TotalLessonCount: 'Total number of lessons',
      TotalHomeWorkApplyedCount: 'Number of student homework submissions',
      TeachersCount: 'Number of teachers',
      FamilyCount: 'Number of families',
      BranchiesCount: 'Number of centers',
      CourseName: 'Course name',
      QuranKaremExamName: 'Exam name',
      Point: 'Points',
      Appreciation: 'Evaluation',
      ExamType: 'Exam type',
      QuestionPoint: 'Question score',
      Question: 'Question text',
      TotalPageNumber: 'Total pages',
      ExamSuperVisor: 'Exam supervisor',
      QuranKaremQuestions: 'Quran Kareem exam questions',
      CourseQuestions: 'Foundational course questions',
      CourseExams: 'Foundational course exams',
      QuranKaremExam: 'Quran Kareem exams',
      CreateQuranKaremExamQuestion: 'Quran Kareem exam question',
      CreateQuranKaremExam: 'Create exam',
      Questions: 'Manage questions',
      CourseExam: 'Course exams',
      ApplyedCourseExam: 'Applicants for foundational course exams',
      ApplyedQuranKaremExam: 'Applicants for exams',
      Branch: 'Branch',
      Exams: 'Manage exams',
      Exam: 'Exams',
      Report: 'Reports',
      Level: 'Level',
      New: 'New',
      HomeWork: 'Homework',
      QuranKarem: 'Quran Kareem',
      Basic: 'General',
      AllUsers: 'Users',
      EndTime: 'End time',
      Homework: 'Homework',
      Clone: 'Clone',
      InsertCsv: 'Insert CSV file',
      TeacherName: 'Teacher name',
      StudentName: 'Student name',
      StudnetName: 'Student name',
      CourseTeachers: 'Course teachers',
      AddLesson: 'Add lesson',
      CourseStudent: 'Course student',
      QuranKaremStagee: 'Quran Kareem stage',
      CourseLevelMangments: 'Course level management',
      AddStage: 'Add stage',
      FromPage: 'From page',
      AddLevelToCourse: 'Add level to course',
      LevelStages: 'Level stages',
      QuranKaremLevel: 'Quran Kareem level',
      ToPage: 'To page',
      Order: 'Order',
      SelectQuestion: 'Select question',
      Stage: 'Stage',
      IsHaveExam: 'Has exam',
      StartTime: 'Start time',
      FromPageSaving: 'From memorization page',
      ToPageSaving: 'To memorization page',
      FromPageReview: 'From review page',
      ToPageReview: 'To review page',
      ProgramsMangments: 'Programs management',
      ProgrameType: 'Program type',
      LessonType: 'Lesson type',
      Content: 'Content',
      FromPart: 'From part',
      FromLesson: 'From lesson',
      TotalPageLesson: 'Total lessons',
      ManagingLessonInfo: 'Manage lesson information',
      LessonsInfo: 'Lesson information',
      ManagingLessonType: 'Manage lesson types',
      ToPart: 'To part',
      ToLesson: 'To lesson',
      PlaceOfResidence: 'Place of residence',
      CertificateAttachment: 'Certificate attachment',
      ArabicFullName: 'Full Arabic name',
      Nationality: 'Nationality',
      FatherName: 'Father name',
      MotherName: 'Mother  name',
      UserIdNumber: 'ID number',
      PlaceOfResidenc: 'Place of residence',
      CertificateName: 'Certificate name',
      BestDayInThisYear: 'Best day this year',
      Birthday: 'Date of birth',
      StudentCount: 'Number of students',
      News: 'News',
      BranchName: 'Center name',
      TrainingName: 'Training name',
      StartDate: 'Start date',
      EndDate: 'End date',
      MaxStudentCount: 'Maximum number of students',
      Price: 'Price',
      IsActive: 'Active',
      CourseReport: 'Course harvest',
      Type: 'Course type',
      AddStudent: 'Add student',
      AddTeacher: 'Add teacher',
      AddLevel: 'Add level',
      TotalPageSavedCount: 'Total pages memorized',
      TotalPartSavedCount: 'Total parts memorized',
      LessonMangments: 'Lesson management',
      StagesMangments: 'Stage management',
      LevelsMangments: 'Category and level management',
      CoursesMangments: 'Course management',
      CoursMangments: 'Course management',
      TeacherCount: 'Number of teachers',
      LogoImg: 'Logo image',
      Courses: 'Curriculums and courses',
      AddressInMap: 'Address on map',
      Add: 'Add',
      ManagerUserId: 'Center manager',
      Lessons: 'Lessons',
      ManagingPositions: 'Position management',
      Activities: 'Activities',
      ManagingCourses: 'Course management',
      ManagingLesson: 'Lesson management',
      Student: 'Students',
      Family: 'Family',
      Teacher: 'Teachers',
      Branches: 'Branches',
      Admins: 'Admins',
      Location: 'Location',
      CallUs: 'Contact us',
      Send: 'Send',
      FollowUs: 'Follow us',
      Newsletter: 'Mailing lists',
      YourEmailAddress: 'Your email address',
      ContactUs: 'Contact us',
      ToGetNews: 'Get all our latest news',
      UsefulLink: 'Quick links',
      VideoUrl: 'Video URL',
      Roles: 'Roles',
      Subscribe: 'Subscribe',
      KeyWord: 'Keyword',
      Visionforummah: 'Gathering for a nation',
      ShortDesc: 'Short description',
      Zar3: 'Zar3',
      Faq: 'Frequently asked questions',
      BasicPages: 'Basic pages',
      BasicPage: 'Basic page',
      MailingList: 'Mailing list',
      Contact: 'Contact us',
      Activity: 'Center activities',
      About: 'About us',
      ReadAll: 'More',
      BadDayInThisYear: 'Worst day this year',
      BadDay: 'Bad day',
      BestDay: 'Best day',
      BestDiffValue: 'Best difference value',
      BadDiffValue: 'Worst difference value',
      BestTipValue: 'Best tip',
      BadTipValue: 'Worst tip',
      BestBarValue: 'Best bar value',
      BadBarValue: 'Worst bar value',
      Today: 'Today',
      Daily: 'Daily',
      Weekly: 'Weekly',
      Monthly: 'Monthly',
      Yearly: 'Yearly',
      AutoChooseSerialNumber: 'Auto-select serial number',
      SerailNumber: 'Serial number',
      MinimumQuantity: 'Minimum quantity',
      Dashboard: 'Dashboard',
      Quantity: 'Quantity',
      CrateionDate: 'Creation date',
      GoToDetails: 'Go to details',
      QuantityInStock: 'Quantity in stock',
      Count: 'Count',
      Tax: 'Tax',
      ProductName: 'Product name',
      Invoice: 'Invoice',
      AddProductToInvoice: 'Add product to invoice',
      Used: 'Used',
      NotUsed: 'Not used',
      SerialNumber: 'Serial number',
      Status: 'Status',
      CreationDate: 'Creation date',
      ChooseFile: 'Choose file',
      UploadFile: 'Upload file',
      DownloadSerialNumberFile: 'Download serial number file',
      ProblemDetail: 'Problem details',
      AddEditCommonMistakes: 'Add/Edit common mistakes',
      Solution: 'Solution',
      Problem: 'Problem',
      MaterialType: 'Material type',
      RemainedWarantyDays: 'Remaining warranty days',
      Catalog: 'Catalog',
      Done: 'Done',
      Required: 'Required',
      NameLocale: 'Name in local language',
      SellingPrice: 'Selling price',
      Cost: 'Cost',
      VendorInformation: 'Vendor information',
      AddNewVendors: 'Add new vendor',
      Vendors: 'Vendors',
      CommonMistakes: 'Common mistakes',
      AddSerialNumbers: 'Add serial numbers',
      InsertSerialNumber: 'Insert serial number',
      FullAddress: 'Full address',
      Value: 'Value',
      ChannelName: 'Channel name',
      FullAdress: 'Full address',
      Latitude: 'Latitude',
      Longitude: 'Longitude',
      State: 'State',
      AddNewContact: 'Add new contact',
      AddNewAddress: 'Add new address',
      CustomerInvoice: 'Customer invoice',
      Contacts: 'Contacts',
      City: 'City',
      Address: 'Address',
      ACTIONS: 'Actions',
      CustomerCategory: 'Customer category',
      FirstName: 'First name',
      CustomerNumber: 'Customer number',
      EditCustomerInformation: 'Edit customer information',
      AddNewCustomerInformation: 'Add new customer information',
      LastName: 'Last name',
      AddressCount: 'Number of addresses',
      ContactCount: 'Number of contacts',
      AddNewCustomer: 'Add new customer',
      PhoneNumber: 'Phone number',
      CustomerLastName: 'Customer last name',
      AddNewInvoice: 'Add new invoice',
      SequenceNumber: 'Sequence number',
      CustomerName: 'Customer name',
      TotalAmount: 'Total amount',
      RemainingAmount: 'Remaining amount',
      Note: 'Note',
      NumberOfOrders: 'Number of orders',
      AddProduct: 'Add product',
      Search: 'Search',
      CustomerInformation: 'Customer information',
      ProductNumber: 'Product number',
      NameAr: 'Name in Arabic',
      Description: 'Description',
      Warranty: 'Warranty',
      Barcode: 'Barcode',
      Notes: 'Notes',
      Available: 'Available',
      Unavailable: 'Unavailable',
      AddCatalog: 'Add catalog',
      AddImage: 'Add image',
      SearchbySerialNumber: 'Search by serial number',
      User: 'User',
      Customers: 'Customers',
      Chat: 'Chat',
      AddService: 'Add service',
      SendNotification: 'Send notification',
      UsersMobile: 'User mobile numbers',
      AddSubSection: 'Add subsection',
      DiscountValue: 'Discount value',
      RegisteredDate: 'Registration date',
      FullName: 'Full name in foreign language',
      Email: 'Email',
      DateBirth: 'Date of birth',
      Phone: 'Phone',
      Gender: 'Gender',
      Product: 'Product',
      UserName: 'Username',
      Rate: 'Rating',
      FileType: 'File type',
      IsVisible: 'Visible for application',
      comments: 'Comments',
      OrderCode: 'Order code',
      Total: 'Total',
      Date: 'Date',
      Section: 'Section',
      SelectUser: 'Select user',
      SubSection: 'Subsection',
      Time: 'Time',
      Services: 'Services',
      SubCategory: 'Subcategory',
      Comments: 'Comments',
      Settings: 'Settings',
      Reports: 'Reports',
      Service: 'Service',
      Img1: 'Image 1',
      Img2: 'Image 2',
      Img3: 'Image 3',
      Img4: 'Image 4',
      Category: 'Category',
      Name: 'Name',
      AddSubCategory: 'Add subcategory',
      Image: 'Image',
      Sliders: 'Sliders',
      Invoices: 'Invoices',
      Actions: 'Actions',
      Text: 'Text',
      Title: 'Title',
      Sections: 'Sections',
      Categories: 'Categories',
      Offers: 'Offers',
      Teams: 'Teams',
      Home: 'Home',
      Clinic: 'Clinic',
      Orders: 'Orders',
      Products: 'Products',
      Messages: 'Messages',
      Dates: 'Dates',
      Users: 'Users',
      AreYouSure: 'Are you sure',
      YouWillNotAble: 'You will not be able to recover this imaginary file!',
      Warning: 'Warning',
      YesDelete: 'Yes, delete it!',
      NoKeep: 'No, keep it',
      Deleted: 'Deleted!',
      YourFileDeleted: 'Your imaginary file has been deleted!',
      Cancelled: 'Cancelled',
      YourImaginarySafe: 'Your imaginary file is safe',
      SomethingWentWrong: 'Something went wrong',
      RemovedSuccessfully: 'Removed successfully',
      UpdatedSuccessfully: 'Updated successfully',
      AddedSuccessfully: 'Added successfully',
      DASHBOARD: 'Dashboard',
      Cancel: 'Cancel',
      Save: 'Save',
      Back: 'Back',
      Reset: 'Reset',
      Edit: 'Edit',
      Create: 'Create',
      Correct: 'Correct',
      IsRequired: 'Required',
      ButThisAlreadyAdded: 'But this has already been added',
      IsDeleting: 'Deleting...',
      Delete: 'Delete',
      DeletePermanently: 'Are you sure you want to permanently delete this record?',
      AddNew: 'Add new'
    }
    
  },
};
